// 라이커, 팔로워 등의 사람목록 팝업
// 이거는 컨텐츠아이디를 받아서 ajax를 날린다.

import React, { useState, useEffect, useRef } from 'react';

import PersonItem from '../common/items/PersonItem';
import { ajaxor2 } from '../common/basic';

import getNLS from '../common/_NLS';

export default props => {
    if (!process.browser || !props || !props.cid) return <></>;
    // console.log("props.me: ", props.me);
    
    const [vThisList, setThisList] = useState([]);

    useEffect(()=>{
        ajaxor2({
            url: '/inspiration/likes/' + props.cid,
            callback: setThisList
        });
    }, [props.cid]);
    

    const jsx = (<div className="this-content">
        <style jsx>{`
.this-content{
    width: 300px;
}

.item{
    height: 54px;
    font-size: 14px;
    color: #343a40;

    padding: 8px 10px;
}

.item.highlight{
    background-color: #55d5ce;
    opacity: 0.1;
}

.dib{
    margin: 0 10px;
}

div.line{
    height: initial;
    line-height: initial;
}

.line{
    text-align: left;
}

.l1{
    text-align: left;
}

.l2{
    font-size: 10px;
    color: #868e96;
}


div.right{
    float:right;
    padding-top: 5px;
}

.no-result{
    text-align: center;
    padding-top: 20px;
}

.title{
    padding: 8px 0 13px;
    text-align: center;
}

.arrow_box{
    padding-bottom: 12px;
}

.results-container{
    height: 300px;
    overflow-y: scroll;
}


@media all and (max-width:606px) {
    .this-content{
        width: auto;
    }
}

`}</style>

        <div className="arrow_box">
            <div className="tabs">
                <div className="title">{getNLS("라이크")}</div>
            </div>
            <div className="results-container">
                {vThisList && vThisList.length > 0 ? '' :
                    <div className="no-result">{getNLS("검색된 결과가 없습니다.")}</div>
                }
                {vThisList && vThisList.map((v, i, a) => (
                    // <TagItem key={v.brandName} brandName={v.brandName} count={v.count} />
                        // psaURL={v.psaURL}
                        // nickname={v.nickname}
                        // // followerCount={v.followerCount}
                        // // followingCount={v.followingCount}
                        // isFollowing={v.isFollowing}

                    <PersonItem key={i} me={v} />
                ))}
            </div>
        </div>



    </div>);

    return (jsx);
};

